import { COVERGO_SAAS_PROD } from "../consts.js"

export const pacifico = {
	// CoverGo PROD
	"pacifico-dev-studio.quote.hk": {
		appConfig: { tenantId: "pacifico_dev", appId: "covergo_crm" },
		envConfig: COVERGO_SAAS_PROD
	}
}
